import React from "react";
// eslint-disable-next-line no-unused-vars
import './index.less';
const TinperNext = window.TinperNext || {};
const { Progress } = TinperNext;

// 异步任务(导入导出进度球，前期先单个文件进度，后期再做其他功能)
export function ProgressInfo(props) {
  const { percentage } = props;
//   yb-async-float-progress
  return (
    <div className="yb-async-float-progress">
      <Progress type="circle" percent={percentage} width={50}></Progress>
    </div>
  );
}
